import { jsx as m } from "react/jsx-runtime";
import { c as l } from "react/compiler-runtime";
import { ToggleButtonGroup as s } from "@mui/material";
import { forwardRef as u } from "react";
const c = u((e, p) => {
  const o = l(5);
  let r;
  o[0] !== e ? ({
    ...r
  } = e, o[0] = e, o[1] = r) : r = o[1];
  let t;
  return o[2] !== r || o[3] !== p ? (t = /* @__PURE__ */ m(s, { ref: p, ...r }), o[2] = r, o[3] = p, o[4] = t) : t = o[4], t;
});
export {
  c as ToggleButtonGroup
};
